import {
  LOAD_START,
  LOAD_SUCCESS,
  LOAD_FAILURE,
  DELETE_START,
  DELETE_SUCCESS,
  DELETE_FAILURE,
  VIEW_START,
  VIEW_SUCCESS,
  VIEW_FAILURE,
  ACCEPT_START,
  ACCEPT_SUCCESS,
  ACCEPT_FAILURE,
  REJECT_START,
  REJECT_SUCCESS,
  REJECT_FAILURE,
  AGREE_START,
  AGREE_SUCCESS,
  AGREE_FAILURE,
  DISAGREE_START,
  DISAGREE_FAILURE,
  DISAGREE_SUCCESS,
  REPLY_START,
  REPLY_FAILURE,
  REPLY_SUCCESS,
  SEND_PAYMENT_START,
  SEND_PAYMENT_SUCCESS,
  SEND_PAYMENT_FAILURE,
  RCV_PAYMENT_START,
  RCV_PAYMENT_SUCCESS,
  RCV_PAYMENT_FAILURE,
  ADD_POST_START,
  ADD_POST_SUCCESS,
  ADD_POST_FAILURE,
  MARK_COMPLETE_START,
  MARK_COMPLETE_SUCCESS,
  MARK_COMPLETE_FAILURE,
  REACTIVATE_START,
  REACTIVATE_SUCCESS,
  REACTIVATE_FAILURE,
  FULFILL_START,
  FULFILL_SUCCESS,
  FULFILL_FAILURE,
  COUNTS_LOADED
} from './actions';

const initialState = {
  loading: false,
  acceptingOrRejecting: false,
  partnerships: [],
  partnership: null,
  pagination: {},
  agreeingOrDisagreeing: false,
  replying: false,
  sendingPayment: false,
  receivingPayment: false,
  addingPost: false,
  completing: false,
  reactivating: false,
  fulfilling: false,
  counts: {}
};

export default (state = {}, action) => {
  let newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case LOAD_START:
      newState.loading = true;
      newState.partnership = null;
      break;
    case LOAD_SUCCESS:
      newState.loading = false;
      newState.partnerships = action.payload.data;
      newState.pagination = action.payload.pagination;
      break;
    case LOAD_FAILURE:
      newState.loading = false;
      break;
    case DELETE_START:
      newState.deleting = true;
      newState.partnerships = newState.partnerships.map(p => {
        p.deleting = false;
        if (p.id === action.payload) {
          p.deleting = true;
        }
        return p;
      });
      break;
    case DELETE_SUCCESS:
      newState.deleting = false;
      newState.partnerships = newState.partnerships.map(p => {
        p.deleting = false;
        return p;
      });
      break;
    case DELETE_FAILURE:
      newState.deleting = false;
      newState.partnerships = newState.partnerships.map(p => {
        p.deleting = false;
        return p;
      });
      break;
    case VIEW_START:
      newState.partnership = null;
      newState.loading = true;
      break;
    case VIEW_SUCCESS:
      newState.loading = false;
      newState.partnership = action.payload;
      break;
    case VIEW_FAILURE:
      newState.loading = false;
      break;
    case ACCEPT_START:
      newState.acceptingOrRejecting = true;
      break;
    case ACCEPT_SUCCESS:
      newState.acceptingOrRejecting = false;
      newState.partnership = action.payload.partnership;
      break;
    case ACCEPT_FAILURE:
      newState.acceptingOrRejecting = false;
      break;
    case REJECT_START:
      newState.acceptingOrRejecting = true;
      break;
    case REJECT_SUCCESS:
      newState.acceptingOrRejecting = false;
      newState.partnership = action.payload.partnership;
      break;
    case REJECT_FAILURE:
      newState.acceptingOrRejecting = false;
      break;
    case AGREE_START:
    case DISAGREE_START:
      newState.agreeingOrDisagreeing = true;
      break;
    case AGREE_SUCCESS:
    case DISAGREE_SUCCESS:
      newState.agreeingOrDisagreeing = false;
      break;
    case AGREE_FAILURE:
    case DISAGREE_FAILURE:
      newState.agreeingOrDisagreeing = false;
      break;
    case REPLY_START:
      newState.replying = true;
      break;
    case REPLY_SUCCESS:
      newState.replying = false;
      newState.partnership = action.payload.partnership;
      break;
    case REPLY_FAILURE:
      newState.replying = false;
      break;
    case SEND_PAYMENT_START:
      newState.sendingPayment = true;
      break;
    case SEND_PAYMENT_SUCCESS:
      newState.sendingPayment = false;
      newState.partnership = action.payload.partnership;
      break;
    case SEND_PAYMENT_FAILURE:
      newState.sendingPayment = false;
      break;
    case RCV_PAYMENT_START:
      newState.receivingPayment = true;
      break;
    case RCV_PAYMENT_SUCCESS:
      newState.receivingPayment = false;
      newState.partnership = action.payload.partnership;
      break;
    case RCV_PAYMENT_FAILURE:
      newState.receivingPayment = false;
      break;
    case ADD_POST_START:
      newState.addingPost = true;
      break;
    case ADD_POST_SUCCESS:
      newState.addingPost = false;
      newState.partnership = action.payload.partnership;
      break;
    case ADD_POST_FAILURE:
      newState.addingPost = false;
      break;
    case MARK_COMPLETE_START:
      newState.completing = true;
      break;
    case MARK_COMPLETE_SUCCESS:
      newState.completing = false;
      newState.partnership = action.payload.partnership;
      break;
    case MARK_COMPLETE_FAILURE:
      newState.completing = false;
      break;
    case REACTIVATE_START:
      newState.reactivating = true;
      break;
    case REACTIVATE_SUCCESS:
      newState.reactivating = false;
      newState.partnership = action.payload.partnership;
      break;
    case REACTIVATE_FAILURE:
      newState.reactivating = false;
      break;
    case FULFILL_START:
      newState.fulfilling = true;
      break;
    case FULFILL_SUCCESS:
      newState.fulfilling = false;
      newState.partnership = action.payload.partnership;
      break;
    case FULFILL_FAILURE:
      newState.fulfilling = false;
      break;
    case COUNTS_LOADED:
      newState.counts = action.payload;
      break;
    default:
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/partnerships/reducer.js